// @flow
import React, { Component } from "react";
import Properties from "../../../Properties";
import { getInit } from "../../global/types/constants";
import { LoadingProgress } from "imagus-components";

import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

const root = Properties.api_root;

const styles = (theme: *): * => ({
  root: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: theme.spacing.unit * 1,
  }),
  curl: {
    wordBreak: "break-all",
    display: "block",
  },
  para: {
    marginTop: ".25em !IMPORTANT",
  },
  title: {
    marginTop: ".8em !IMPORTANT",
    marginBottom: ".8em !IMPORTANT",
  },
});

type FormDataType = {
  default_value: ?string,
  multiple: boolean,
  description: string,
  required: boolean,
  type: string,
  example: string,
  name: string
};

type DocType = {
    url_args: Array<FormDataType>,
    endpoint: string,
    description: string,
    form_data: Array<FormDataType>,
    query_args: Array<FormDataType>,
    form_files: Array<FormDataType>,
    methods: Array<string>
};

type DocumentGeneratePropsType = {
  endpoint: string,
  classes: { [key: string]: * }
};

type DocumentGenerateStatesType = {
  docs: Array<*>
};

const formatArgs = (doc: DocType, argsType: string): * => {
  // let queryArgs = [];
  // if (doc.query_args.length > 0) {
  return doc[argsType].map((item: FormDataType, i: number): * => {
    if (i === 0) {
      return (<span key={item.name}>{item.name}=<strong>YOUR_{item.name.toUpperCase()}</strong></span>);
    } else {
      return (<span key={item.name}>{"&" + item.name + "="}<strong>YOUR_{item.name.toUpperCase()}</strong></span>);
    }
  });
};

const formatMultiFormData = (doc: DocType): * => {
  let args = doc.form_data.map((item: FormDataType): * => {
    return <span key={item.name}>--form "{item.name}=<strong>YOUR_{item.name.toUpperCase()}</strong>"</span>;
  });

  doc.form_files.forEach((item: FormDataType) => {
    args.push(<span key={item.name}> --form "{item.name}=@<strong>LOCATION_TO_YOUR_{item.name.toUpperCase()}</strong>"</span>);
  });

  return args;
};

const createCurlScript = (doc: DocType, classes: { [key: string]: * }): * => {
  let queryArgs = formatArgs(doc, "query_args");
  let formData = [];
  if (doc.form_files.length === 0) {
    let returnedFormData = formatArgs(doc, "form_data");
    if (returnedFormData.length > 0) {
      formData = ["--data \"", ...returnedFormData, "\""];
    }
  } else {
    formData = formatMultiFormData(doc);
  }

  let urlArr = [doc.endpoint];
  doc.url_args.forEach((item: FormDataType) => {
    urlArr = urlArr.slice(0, urlArr.length - 1).concat(urlArr[urlArr.length - 1].split(`<${item.name}>`));
    urlArr.splice(urlArr.length-1, 0, <strong key={item.name} >YOUR_{item.name.toUpperCase()}</strong>);
  });
  return (
    <Typography variant="subtitle1" className={classes.para}>{/*ALTERNATIVE word-break: break-all;*/}
      <strong>cURL: </strong>
      <span className={classes.curl}>curl -i -b cookiejar -c cookiejar "{root}{urlArr}{queryArgs.length > 0 ? "?" : ""}{queryArgs}" {formData}</span>
    </Typography>
  );
};

const createFormDataItem = (form_item: FormDataType,  classes: { [key: string]: * }): * => (
  <Paper key={"form-item" + form_item.name} className={classes.root} elevation={1}>
    <Typography variant="h6">{form_item.name}</Typography>
    {form_item.description && <Typography variant="subtitle1" className={classes.para}><strong>Description:</strong> {form_item.description}</Typography>}
    <Typography variant="subtitle1" className={classes.para}><strong>Type:</strong> {form_item.type}</Typography>
    <Typography variant="subtitle1" className={classes.para}><strong>Required:</strong> {String(form_item.required)}</Typography>
    {!form_item.required && <Typography variant="subtitle1" className={classes.para}><strong>Default Value:</strong> {String(form_item.default_value)}</Typography>}
  </Paper>
);

const createFormDataList = (form_data: Array<FormDataType>, title: string, classes: { [key: string]: * }): * => {
  if(form_data.length > 0) {
    return (
      <div>
        <Typography variant="h6" className={classes.title}>{title}</Typography>
        {form_data.map((form_item: FormDataType): * => (
          createFormDataItem(form_item, classes)
        ))}
      </div>
    );
  }
  else {
    return null;
  }
};

const createDocumentationitem = (doc: DocType, classes: { [key: string]: * }): * => (
  <Paper key={doc.methods[0] + doc.endpoint} className={classes.root} elevation={4}>
    <Typography variant="h6">
      <span className="right-margin-10">
        {doc.methods.map((method: string): * => (method + " "))}
      </span>
      {doc.endpoint}
    </Typography>
    <Typography variant="subtitle1" className={classes.para}>{doc.description}</Typography>
    {createCurlScript(doc, classes)}
    <Divider />
    {createFormDataList(doc.url_args, "URL Arguments", classes)}
    {createFormDataList(doc.query_args, "Query Arguments", classes)}
    {createFormDataList(doc.form_data, "Form Data", classes)}
    {createFormDataList(doc.form_files, "Form Files", classes)}
  </Paper>
);

class DocumentGenerate extends Component<DocumentGeneratePropsType, DocumentGenerateStatesType> {
  constructor(props: DocumentGeneratePropsType) {
    super(props);
    this.state = {
      docs: []
    };
  }

  componentDidMount() {
    this.fetchDocs();
  }

  fetchDocs = async (): * => {
    const res = await fetch(`${root}${this.props.endpoint}`, getInit);
    const json_res = await res.json();
    this.setState({ docs: json_res });
  }

  render(): * {
    const classes = this.props.classes;
    if(this.state.docs.length === 0){
      return (
        <LoadingProgress />
      );
    }
    else {
      return (
        <Grid container spacing={24}>
          <Grid item xs={12}>
            {this.state.docs.map((doc: DocType): * => (
              createDocumentationitem(doc, classes)
            ))}
          </Grid>
        </Grid>
      );
    }
  }
}

export default withStyles(styles)(DocumentGenerate);
